module.exports = __webpack_public_path__ + "static/dap_hero_dsktp-67f710880faed16623956e6306a40077.png";